import { z } from 'zod';

export const lookupItemSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
});

export type LookupItem = z.infer<typeof lookupItemSchema>;
